<template>
  <div class="content1">
    <div class="query_con">
      <el-form :inline="true" :model="query" class="demo-form-inline">
        <el-form-item label="工号">
          <el-input
            v-model="query.receiverEmpno"
            placeholder="请输入工号"
            style="width: 150px"
            clearable
            @change="queryData"
          ></el-input>
        </el-form-item>
        <el-form-item label="参与状态">
          <el-select
            v-model="query.cardType"
            placeholder="请选择参与状态"
            style="width: 150px"
            clearable
            @change="queryData"
          >
            <el-option
              v-for="item in optionsType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button class="add" @click="queryParams">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table_con">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        v-loading="tableLoading"
        :height="windowHeight"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="index"
          label="序号"
          align="center"
          min-width="60"
        >
        </el-table-column>
        <el-table-column
          prop="epbActivityName"
          label="活动标题"
          align="center"
          min-width="100"
        >
        </el-table-column>

        <el-table-column
          prop="empName"
          label="姓名"
          align="center"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          prop="empNo"
          label="工号"
          align="center"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          prop="departmentName"
          label="部门"
          align="center"
          min-width="80"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="enterTime"
          label="报名活动日期"
          align="center"
          min-width="100"
          show-overflow-tooltip
        >
        </el-table-column>
        <!-- <el-table-column
          prop="signInStartTime"
          label="实际参与日期"
          align="center"
          min-width="100"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="sendPosition"
          label="报名活动时间"
          align="center"
          min-width="100"
          show-overflow-tooltip
        >
        </el-table-column> -->
        <el-table-column
          prop="signInStartTime"
          label="签到时间"
          align="center"
          min-width="80"
        >
        </el-table-column>
        <el-table-column
          prop="signInEndTime"
          label="签退时间"
          align="center"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          label="参与状态"
          align="center"
          min-width="100"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.signInStart == 1">已参与</span>
            <span v-else>未参与</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="updateTime"
          label="更新时间"
          align="center"
          min-width="100"
        >
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination_con">
      <el-pagination
        @size-change="handleSizeChange1"
        @current-change="handleCurrentChange1"
        :current-page="pageData.page"
        :page-sizes="[20, 40, 60, 80, 100]"
        :page-size="pageData.pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import api from "@/apis/medal";
export default {
  name: "badgeMaintain",
  data() {
    return {
      query: {
        cardType: 1,
        receiverEmpno: "",
        senderEmpno: ""
      },
      pageData: {
        page: 1,
        pageSize: 20
      },
      total: 0,
      tableData: [],
      tableLoading: false,
      windowHeight: 350,
      isShowRecord: 1,
      optionsType: [
        {
          label:'全部',
          value:1
        },
        {
          label:'已参加',
          value:2
        },
        {
          label:'未参加',
          value:3
        },
      ]
    };
  },
  mounted() {
    this.upload = api.upload;
    this.imgUrl = api.imgUrl;
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.queryData();
  },
  // 销毁
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      // 使用 window.innerHeight 获取窗口的高度
      this.$nextTick(() => {
        this.windowHeight = window.innerHeight - 300;
      });
    },
    queryParams() {
      this.queryData();
    },

    // 选择table
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 分页
    handleSizeChange1(val) {
      this.pageData.pageSize = val;
      this.queryData();
    },
    // 当前页数
    handleCurrentChange1(val) {
      this.pageData.page = val;
      this.queryData();
    },
    // 查询 列表
    queryData() {
      const json = {
        ...this.pageData,
        empNo:this.query.receiverEmpno,
        state:this.query.cardType
        // ...this.query,
        // username: this.$store.state.userInfo.username
      };
      this.tableLoading = true;
      api
        .pubBenefitAdminActivityListApi(json)
        .then(res => {
          if (res.code == 200) {
            this.tableData = res.data.list;
            this.tableData.forEach(item => {
              item.signInStartTime = item.signInStartTime
                ? this.$moment(item.signInStartTime).format("YYYY-MM-DD HH:mm:ss")
                : "";
              item.signInEndTime = item.signInEndTime
                ? this.$moment(item.signInEndTime).format("YYYY-MM-DD HH:mm:ss")
                : "";
              item.enterTime = item.enterTime
                ? this.$moment(item.enterTime).format("YYYY-MM-DD HH:mm:ss")
                : "";
              item.updateTime = item.updateTime
                ? this.$moment(item.updateTime).format("YYYY-MM-DD HH:mm:ss")
                : "";
            })
            this.total = res.data.total;
          }
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },

  }
};
</script>

<style lang="scss" scoped>
.content1 {
  background-color: #f2fcf9;

  .query_con {
    // margin: 30px 40px 20px 40px;
    padding: 40px 0 0px 40px;
    // border: 1px solid #e5e5e5;
    border-radius: 5px;
    ::v-deep {
      .el-date-editor .el-range-separator {
        padding: 0 28px;
      }
    }
    .add {
      color: #fff;
      background-color: #23c0d8;
      border-color: #23c0d8;
    }
  }
  .operate {
    margin: 20px 40px;
    .add {
      color: #fff;
      background-color: #23c0d8;
    }
  }
  .table_con {
    background-color: #fff;
    border: 1px solid #e2e6e5;
    padding: 40px 20px;
    margin: 0 40px;
    border-radius: 5px;
  }
  .pagination_con {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
    padding-right: 40px;
  }
  .dialog-footer {
    .add {
      color: #fff;
      background-color: #23c0d8;
    }
  }
  ::v-deep .hide .el-upload--picture-card {
    display: none;
  }
}
</style>
